
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 23 23","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M3.978 5.688c-.373-.61-.566-1.362-.566-2.275C3.413 1.612 4.768 0 6.825 0c2.061 0 3.723 1.38 4.55 3.542C12.202 1.381 13.864 0 15.925 0c2.058 0 3.412 1.612 3.412 3.413 0 .913-.192 1.664-.565 2.275h1.703a2.275 2.275 0 012.275 2.275v2.275a2.275 2.275 0 01-2.275 2.274v7.963A2.275 2.275 0 0118.2 22.75H4.55a2.275 2.275 0 01-2.275-2.275v-7.963A2.275 2.275 0 010 10.238V7.963a2.275 2.275 0 012.275-2.276h1.703zm6.26 2.275H2.275v2.275h7.963V7.963zm10.237 2.275h-7.963V7.963h7.963v2.275zM10.237 20.474v-7.963H4.55v7.963h5.688zm7.963 0h-5.688v-7.963H18.2v7.963zM6.825 2.275c-.706 0-1.138.514-1.138 1.138 0 1.425 1.157 2.103 3.901 2.245-.305-2.119-1.441-3.383-2.763-3.383zm6.256 3.383c.305-2.119 1.442-3.383 2.764-3.383.705 0 1.137.514 1.137 1.138 0 1.425-1.157 2.103-3.9 2.245z"}})])
          )
        }
      }
    